<template>
  <div
    class="page--approve-payment-bulk"
    :style="`min-height: ${height}px`"
  >
    <Header :kind="kind" :status="currentStatus" />

    <div class="form-fw__content">
      <Breadcrumb :step="breadcrumb.currentStep" :type="breadcrumb.type" />

      <StepOne
        v-if="breadcrumb.currentStep === 1"
        :kind="kind"
        :maxLines="maxLines"
        :worksheetTarget="xlsx.worksheetTarget"
        :supportedFileTypes="xlsx.supportedFileTypes"
        @updateStep="updateStep"
      />

      <StepTwo
        v-if="breadcrumb.currentStep === 2"
        :kind="kind"
        :maxLines="maxLines"
        :worksheetTarget="xlsx.worksheetTarget"
        :supportedFileTypes="xlsx.supportedFileTypes"
        :data="payload"
        @updateStep="updateStep"
      />

      <StepThree
        v-if="breadcrumb.currentStep === 3"
        :kind="kind"
        :total="finalTotal"
      />
    </div>

    <Footer
      v-if="breadcrumb.currentStep > 1"
      :kind="kind"
      :status="currentStatus"
      :step="breadcrumb.currentStep"
      :data="payload"
      @updateRequestStatus="updateRequestStatus"
      @updateStep="updateStep"
    />
  </div>
</template>

<script>
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'
import Header from 'components/bulkImport/Header'
import Breadcrumb from 'components/bulkImport/breadcrumb'
import StepOne from 'components/bulkImport/stepOne'
import StepTwo from 'components/bulkImport/stepTwo'
import StepThree from 'components/bulkImport/stepThree'
import Footer from 'components/bulkImport/Footer'

export default {
  name: 'ApprovePaymentBulkOperationPage',
  components: {
    Header,
    Breadcrumb,
    StepOne,
    StepTwo,
    StepThree,
    Footer
  },
  computed: {
    isLoading () {
      return this.currentStatus === STATUS_IS_LOADING
    },

    isSuccess () {
      return this.currentStatus === STATUS_SUCCESS
    },

    isFailed () {
      return this.currentStatus === STATUS_FAILED
    },

    height () {
      return document.body.offsetHeight
    },

    maxLines () {
      return 1000
    },

    finalTotal () {
      const updates = this.payload && this.payload.updates
        ? this.payload.updates
        : 0
      const insert = this.payload && this.payload.insert
        ? this.payload.insert
        : 0
      return updates + insert
    }
  },
  data () {
    return {
      kind: 'approvePayment',
      submitForm: false,
      data: null,
      currentStatus: null,
      breadcrumb: {
        currentStep: 1,
        type: 'success'
      },
      xlsx: {
        worksheetTarget: ['New Orders', 'Old Orders'],
        supportedFileTypes: [
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          'application/vnd.ms-excel'
        ]
      },
      payload: {}
    }
  },
  methods: {
    updateRequestStatus (status) {
      this.currentStatus = status
    },

    updateBreadcrumb ({ currentStep, type }) {
      this.breadcrumb = {
        ...this.breadcrumb,
        currentStep,
        type
      }
    },

    updatePayload (payload) {
      this.payload = payload
    },

    updateStep ({ currentStep, type, payload = {} }) {
      this.updateBreadcrumb({ currentStep, type })
      this.updatePayload(payload)
    },

    setChatPosition (bottom = null, right = null) {
      const chat = document.querySelector('#oloswcdl-root .oloswebchat-main .cta-button')
      if (chat) {
        chat.style.bottom = bottom
        chat.style.right = right
      }
    }
  },
  watch: {
    'breadcrumb.currentStep' (step) {
      if (step > 1) {
        this.setChatPosition('75px', '10px')
        return
      }

      this.setChatPosition()
    }
  },
  beforeDestroy () {
    this.setChatPosition()
  }
}
</script>
